/**
 * Keyboard Usage Indicator
 * 
 * This script adds a "is-using-keyboard" class to the body when the user is using the keyboard.
 * It removes the class when the user clicks with the mouse.
 * 
 * Additionally, if using keyboard, focused elements will get the "has-keyboard-focus" class.
 * 
 * @author jjarolim
 */

const init = () => {

    // Add "using-keyboard" class to body

    document.body.addEventListener('keydown', function (event) {
        if (event.key === 'Tab') {
            document.body.classList.add('is-using-keyboard');
        }
    });

    // Remove "using-keyboard" class from body if mouse was clicked

    document.body.addEventListener('mousedown', function (event) {
        if (event.button === 0) { // Left mouse button only
            document.body.classList.remove('is-using-keyboard');
        }
    });

    // Add "keyboard-focus" class to focused elements if using keyboard

    document.body.addEventListener('focusin', function (event) {
        if (document.body.classList.contains('is-using-keyboard')) {
            event.target.classList.add('has-keyboard-focus');
        } else {
            event.target.classList.remove('has-keyboard-focus');
        }
    });

    document.body.addEventListener('focusout', function (event) {
        event.target.classList.remove('has-keyboard-focus');
    });

}

export { init }